export interface ITopUniversities {
  id: string;
  name: string;
  logo?: string;
  description: string;
  title?: string;
  direction_count: string;
  type: string;
}

export interface IAllUniversitiesRes {
  data: IAllUniversities[];
  pagination: {
    total_items: number;
    size: number;
    page: number;
  };
}

export interface IAllUniversities {
  id: string;
  name: string;
  phone: string;
  map: string;
  address: string;
  keywords: string;
  description: string;
  status: string;
  email: string;
  site: string;
  faks: string;
  address_id: string;
  image: string;
  logo: string;
  title: string;
  type: string;
  telegram_group_id: string;
  direction_count: string;
  students_count?: string;
  graduate_students_count?: string;
  courses_count?: string;
  experience_years_count?: string;
  latitude?: number;
  longitude?: number;
  instagram: string;
  telegram: string;
  youtube: string;
  admission_end_date: string | null;
  admission_start_date: string | null;
  max_contract_price: string | null;
  min_contract_price: string | null;
  youtube_embed: string | null;
  long_description: string | null;
  file: ILicenseFile | null;
  course_details: ICourseDetails[];
  slug?: string;
  is_recommended?: boolean;
  test_available?: boolean;
}

export interface ICourseDetails {
  direction_name?: string;
  grant_count?: null | string;
  contract_count?: null | string;
}

export interface IUniversitySort {
  year: number;
  studies: string[];
  languages: string[];
}

export interface IUniversityBall {
  direction_name: string;
  direction_code: string;
  subject_1: string;
  subject_2: string;
  grant_ball: number;
  contract_ball: number;
  grant_count: number;
  contract_count: number;
}

export interface IUniversityCourse {
  id: number;
  passing_ball: number;
  course_name: string;
  subject1: string;
  subject2: string;
}

export interface ILicenseFile {
  id?: string;
  university_id?: null | string;
  name?: null | string;
}

export enum UniversityTypes {
  PRIVATE = 'private',
  PUBLIC = 'public'
}
